var OSS = require('ali-oss');
export default function client() {
  var client = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAIMHMfXT67uXmD',    
    // accessKeyId: 'LTAI5tCrtPWKRL8xqv5zMWeD',    
    accessKeySecret: 'sPtJY6ZmhWvKBkDwybYxJZkvGhVcWP',
    // accessKeySecret: 'LBjPJtHDHCVrp1GkvrFYnpOV2lkItG',
    bucket: 'zdht-it618jifen'
  })  //后端提供数据
  return client
}


// WEBPACK FOOTER //
// ./src/configOss.js